// Strony indeksowalne mają najwyżej 4 filtry (patrz getFollow w seo.helper.ts), więc limit
// nie może dotknąć niczego, co trafia do wyszukiwarek. Powyżej limitu agregacje kategorii
// stają się na tyle kosztowne, że wysycają pulę wyszukiwania Elasticsearcha.
export const FILTERS_LIMIT = 15;
